import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
// import '../styleDrawer.css';
import Snackbar from '@mui/material/Snackbar';
import {loadingCableDataComponent, loadingCableTypeDataComponent,
        loadingCouplingDataComponent, loadingFobDataComponent,
        loadingContractorDataComponent, loadingRankCableDataComponent,
        loadingRankComponentDataComponent, loadingOwnerWellDataComponent,
        loadingOwnerPillarDataComponent, loadingPonBoxDataComponent,
        loadingDividerDataComponent,
        loadingBoxDataComponent,
        loadingPolishingDataComponent,
        loadingCassetteDataComponent} from '../../Optics/LoadingData/LoadingDataComponents'; 
import CustomSnackbar from '../../Optics/Components/CustomSnackbar'; 
import CableContainerCanton from '../../Optics/Drawer/DrawerEditCanton/ContainerEditCanton/CableContainerCanton'
import CableContainerEdit from './EditContainer/CableContainerEdit';
import { WriteCableConstrucrion, WriteCouplingConstruction, WriteFobConstruction, WritePonBoxConstruction } from '../WriteData/WriteConstructCommunications';
import CouplingContainerEdit from './EditContainer/CouplingContainerEdit';
import FobContainerCanton from '../../Optics/Drawer/DrawerEditCanton/ContainerEditCanton/FobContainerCanton';
import FobContainerEdit from './EditContainer/FobContainerEdit';
import PonBoxContainerCanton from '../../Optics/Drawer/DrawerEditCanton/ContainerEditCanton/PonBoxContainerCanton';
import PonBoxContainerEdit from './EditContainer/PonBoxContainerEdit';
import { WritePonBoxHighway } from '../../Optics/WriteData/WriteHighwayCommunications';
// import CouplingContainerCanton from './ContainerEditCanton/CouplingContainerCanton';
// import FobContainerCanton from './ContainerEditCanton/FobContainerCanton'
// import PonBoxContainerCanton from './ContainerEditCanton/PonBoxContainerCanton';
// import {WriteLineOpticCanton} from '../../WriteData/WriteCantonCommunications'; 
// import { WriteWellHighway, WritePillarHighway, WriteCouplingHighway, WriteFobHighway, WritePonBoxHighway, WritePillarManuallyCanton } from '../../WriteData/WriteHighwayCommunications';   
// import ManholeContainerSummit from '../DrawerEditSummit/ContainerEditSummit/ManholeContainerSummit';   
// import PillarContainerSummit from '../DrawerEditSummit/ContainerEditSummit/PillarContainerSummit';  
// import { ROLE_SENIOR_MASTER } from '../../Constants/ConstantsOptics';


const DrawerEditComponent = ({ openEditCantonDrawer, toggleEditCantonDrawer, 
        handleCableSelectChange, handleLineStyleSelectChange, isLineDrawing,
         handleStartDrawing, handleStopDrawing,toggleManholeMarker,manholeMarker,
         togglePillarMarker, pillarMarker, toggleCouplingMarker, couplingMarker,
         toggleFobMarker, fobMarker, coordinatesManhole, setCoordinatesManhole,
         coordinatesPillar, setCoordinatesPillar, coordinatesCoupling, setCoordinatesCoupling,
         coordinatesFob, setCoordinatesFob, coordinatesCableLine, setCoordinatesCableLine, cableOpticId, 
         cableTypeId, cantonRefresh,setLengthCable,lengthCable, selectedRankCouling,
         setSelectedRankCoupling, handleChangeRankComponentCoupling, selectedRankFob, 
         setSelectedRankFob, handleChangeRankComponentFob, user, selectedCity, highwayTerritory, togglePonBoxMarker, 
         ponBoxMarker,coordinatesPonBox, setCoordinatesPonBox, cantonFobRefresh, cantonCouplingRefresh, cantonWellRefresh,
         cantonPillarRefresh, cantonPonBoxRefresh, cantonCablaRefresh, selectedCanton, selectedRegoin, selectedArea, role, projectId,
         cantonCablaByIdRefresh
        }) => {

         

//#region ПЕРЕМЕННЫЕ
  //Snackbar
 const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  // Кабель 
  const [isVisibleCable, setIsVisibleCable] = useState(false);
  const [cableData, setCableData] = useState([]);
  const [cableTypeData, setCableTypeData] = useState([]);
  const [contractorData, setContractorData] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [selectedRankCable, setSelectedRankCable] = useState(null);
  const commentTextAreaRefCable = useRef(null);
  const [commentCable, setCommentCable] = useState('');
  const [selectedCable, setSelectedCable] = useState([]);
  const [selectedTypeCable, setSelectedTypeCable] = useState(null);
  const [rankCableData, setRankCableData] = useState([])

  // Колодец
  const [isVisibleManhole, setIsVisibleManhole] = useState(false);
  const commentTextAreaRefManhole = useRef(null);
  const [commentManhole, setCommentManhole] = useState('');
  const [ownerWellData, setOwnerWellData] = useState(null);
  const [selectedOwnerWell, setSelectedOwnerWell] = useState([]);
  
  // Опора 
  const [isVisiblePillar, setIsVisiblePillar] = useState(false);
  const commentTextAreaRefPillar = useRef(null);
  const [commentPillar, setCommentPillar] = useState('');
  const [ownerPillarData, setOwnerPillarData] = useState(null);
  const [selectedOwnerPillar, setSelectedOwnerPillar] = useState([]);
  const [coordinatesManuallyPillae, setCoordinatesManuallyPillae] = useState(''); 
  const [manualInputEnabledPillar, setManualInputEnabledPillar] = useState(false);

  //Муфта
  const [isVisibleCoupling, setIsVisibleCoupling] = useState(false);
  const commentTextAreaRefCoupling = useRef(null);
  const [commentCoupling, setCommentCoupling] = useState('');
  const [couplingData, setCouplingData] = useState([]);
  const [selectedCoupling, setSelectedCoupling] = useState(null);
  const [rankComponentData, setRankComponentData] = useState([]);
  const [weldsCoupling, setWeldsCoupling] = useState('');

  //Фоб
  const [isVisibleFob, setIsVisibleFob] = useState(false);
  const commentTextAreaRefFob = useRef(null);
  const [commentFob, setCommentFob] = useState('');
  const [fobData, setFobData] = useState([]);
  const [selectedFob, setSelectedFob] = useState(null);
  const [selectedBox, setSelectedBox] = useState(null);
  const [selectedPolishing, setSelectedPolishing] = useState(3);


  //Пон-бокс
   const [isVisiblePonBox, setIsVisiblePonBox] = useState(false);
   const commentTextAreaRefPonBox = useRef(null);
   const [commentPonBox, setCommentPonBox] = useState('');
  const [ponboxData, setPonBoxData] = useState([]);
   const [selectedPonBox, setSelectedPonBox] = useState(null);
//#endregion  

  const [dividerData, setDividerData] = useState([]);
  const [boxData, setBoxData] = useState([]);
  const [polishingData, setPolishingData] = useState([]);
  const [adapterCount, setAdapterCount] = useState('24');
  const [pigtailCount, setPigtailCount] = useState('24');

  const [adapterPonBoxCount, setAdapterPonBoxCount] = useState('2');
  const [pigtailPonBoxCount, setPigtailPonBoxCount] = useState('2');

  const [cassetteData, setCassetteData] = useState([]);
  const [showCassetteCable, setShowCassetteCable] = useState(false);
  const [selectedPolishingPatch, setSelectedPolishingPatch] = useState(3);
  const [selectedCassetteModel, setSelectedCassetteModel] = useState(8);
  const [cassetteCableCount, setCassetteCableCount] = useState('0');
  const [patchCableCount, setPatchCableCount] = useState('0');


  const [reserve, setReserve] = useState('');
  const [forwarding, setForwarding] = useState(0);

const [selectedDividerOption, setSelectedDividerOption] = useState(null);
const [dividerId, setDividerId] = useState("");

const [selectedDividerOptionFob, setSelectedDividerOptionFob] = useState(null);
const [dividerIdFob, setDividerIdFob] = useState("");
  
//#region КАБЕЛЬ
// Кабель

const handleChangeContractor = (event) => {
  const selectedContractor = event.target.value;
  setSelectedContractor(selectedContractor);
};

const handleChangeRankCable = (event) => {
  const selectedRankCable = event.target.value;
  setSelectedRankCable(selectedRankCable);
};

function toggleVisibilityCable() {
  setIsVisibleCable(!isVisibleCable);
}

const handleCommentChangeCable = (event) => {
  setCommentCable(event.target.value);
}

 const handleAdapterChange = (e) => {
    setAdapterCount(e.target.value);
  };

  const handlePigtailChange = (e) => {
    setPigtailCount(e.target.value);
  };

  const handleAdapterPonBoxChange = (e) => {
    setAdapterPonBoxCount(e.target.value);
  };

  const handlePigtailPonBoxChange = (e) => {
    setPigtailPonBoxCount(e.target.value);
  };

  

// const handleChangeCableSelect = (event) => {
//   const selectedCable = event.target.value;
//   setSelectedCable(selectedCable);
// };

const handleChangeCableSelect = (selectedOption) => {
  if (!selectedOption) {
    // Если пользователь очистил выбор
    setSelectedCable([]);
    return;
  }

  setSelectedCable(selectedOption.value);
};

const handleChangeCableType = (event) => {
  const selectedTypeCable = event.target.value;
  setSelectedTypeCable(selectedTypeCable);

  const id = selectedTypeCable.split(',')[0]; // Получаем только id
  if(id == 2 || id == 4 || id == 5){
    setForwarding(0);
    setShowCassetteCable(false);
    setSelectedPolishingPatch(3);
    setSelectedCassetteModel(8);
    setCassetteCableCount('0');
    setPatchCableCount('0');
  }else {
    setForwarding(1);
  }
};

 const handleCableConstructSave = async () => {
    WriteCableConstrucrion( coordinatesCableLine, commentTextAreaRefCable,selectedContractor, cableOpticId, cableTypeId,  
          isLineDrawing, showSnackbar, setCoordinatesCableLine, setCommentCable, setSelectedCable,
          setSelectedTypeCable,setSelectedContractor,cantonCablaRefresh, setLengthCable, lengthCable, setSelectedRankCable,
          selectedRankCable, user, projectId, reserve, setReserve, cantonCablaByIdRefresh, forwarding, setForwarding, setShowCassetteCable,
          selectedPolishingPatch, setSelectedPolishingPatch, selectedCassetteModel, setSelectedCassetteModel, cassetteCableCount, setCassetteCableCount,
          patchCableCount, setPatchCableCount);
};


 
//#endregion  

//#region КОЛОДЕЦ
// Колодец

function toggleVisibilityManhole() {
  setIsVisibleManhole(!isVisibleManhole);
}

const handleCommentChangeManhole = (event) => {
  setCommentManhole(event.target.value);
}

const handleChangeOwnerWell = (event) => {
  const selectedOwnerWell = event.target.value;
  setSelectedOwnerWell(selectedOwnerWell);
};

async function wellSave(event) { 
  // WriteWellHighway(event, coordinatesManhole, commentTextAreaRefManhole, selectedCity, manholeMarker, 
  //   showSnackbar, setCoordinatesManhole, setCommentManhole,cantonWellRefresh,
  //   selectedOwnerWell,setSelectedOwnerWell, user, highwayTerritory);
 
}
//#endregion  

//#region ОПОРА
// Опора

function toggleVisibilityPillar() {
  setIsVisiblePillar(!isVisiblePillar);
}

const handleChangeOwnerPillar = (event) => {
  const selectedOwnerPillar = event.target.value;
  setSelectedOwnerPillar(selectedOwnerPillar);
};

const handleCommentChangePillar = (event) => {
  setCommentPillar(event.target.value);
}

const handleInputChangePillar = (e) => {
  setCoordinatesManuallyPillae(e.target.value || ''); 
};

const toggleManualPillarInput = () => {
  setManualInputEnabledPillar(prev => !prev);
  setCoordinatesManuallyPillae('');
  setSelectedOwnerPillar([]);
  setCommentPillar('');
};

async function pillarSave(event) {
  // WritePillarHighway(event, coordinatesPillar, commentTextAreaRefPillar, selectedCity, pillarMarker,
  //                    showSnackbar, setCoordinatesPillar, setCommentPillar,cantonPillarRefresh,
  //                    selectedOwnerPillar,setSelectedOwnerPillar, user, highwayTerritory);
}

async function  pillarManuallySave (event) {

  // const coords = coordinatesManuallyPillae.split(',').map(coord => parseFloat(coord.trim()));    
  //    if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          
  //       WritePillarManuallyCanton(event, coords[0], coords[1], selectedCanton, selectedRegoin, selectedArea, user, commentTextAreaRefPillar, selectedOwnerPillar,
  //         cantonPillarRefresh, setCoordinatesManuallyPillae, showSnackbar );

  //    } else {
  //      showSnackbar(`Введите корректные координаты в формате "50.4488, 30.5255"`, 'snackbarWarning');
  //    }
}
//#endregion

//#region МУФТА

function toggleVisibilityCoupling() {
  setIsVisibleCoupling(!isVisibleCoupling);
}

const handleCommentChangeCoupling = (event) => {
  setCommentCoupling(event.target.value);
}

const handleChangeCoupling = (event) => {
  const selectedCoupling = event.target.value;
  setSelectedCoupling(selectedCoupling);
};



async function couplingConstructSave(event) {
  WriteCouplingConstruction(event, coordinatesCoupling, selectedCoupling, commentTextAreaRefCoupling, 
    selectedCity, couplingMarker, showSnackbar, setCoordinatesCoupling, 
    setCommentCoupling, cantonCouplingRefresh, setSelectedCoupling,
    selectedRankCouling, setSelectedRankCoupling, user,highwayTerritory, projectId, weldsCoupling, setWeldsCoupling);
 }
//#endregion

function toggleVisibilityFob() {
  setIsVisibleFob(!isVisibleFob);
}

const handleCommentChangeFob = (event) => {
  setCommentFob(event.target.value);
}

const handleChangeFob = (event) => {
  const selectedFob = event.target.value;
  setSelectedFob(selectedFob);
};

const handleChangePolishing = (event) => {
  const selectedPolishing = event.target.value;
  setSelectedPolishing(selectedPolishing);
};

const handleChangeBox = (event) => {
  const selectedBox = event.target.value;
  setSelectedBox(selectedBox);
};

async function fobConstructSave(event) {
   WriteFobConstruction(event, coordinatesFob, selectedFob, commentTextAreaRefFob, selectedCity, fobMarker, showSnackbar, 
     setCoordinatesFob, setCommentFob, cantonFobRefresh, setSelectedFob,selectedRankFob, setSelectedRankFob, user, 
     highwayTerritory, projectId, dividerIdFob, setDividerIdFob, setSelectedDividerOptionFob, selectedBox, adapterCount,
     selectedPolishing, pigtailCount, setBoxData,setAdapterCount, setPigtailCount, setSelectedPolishing );
}
//#endregion

//#region ПОН-БОКС
function toggleVisibilityPonBox() {
  setIsVisiblePonBox(!isVisiblePonBox);
}

const handleChangePonBox = (event) => {
  const selectedPonBox = event.target.value;
  setSelectedPonBox(selectedPonBox);
};

const handleChangeDividerSelect = (selectedOption) => {
  if (!selectedOption) {
    setSelectedDividerOption(null);
    setDividerId("");
    return;
  }

  setSelectedDividerOption(selectedOption);
  setDividerId(selectedOption.value);
};

const handleChangeDividerSelectFob = (selectedOption) => {
  if (!selectedOption) {
    setSelectedDividerOptionFob(null);
    setDividerIdFob("");
    return;
  }

  setSelectedDividerOptionFob(selectedOption);
  setDividerIdFob(selectedOption.value);
};

const handleCommentChangePonBox = (event) => {
  setCommentPonBox(event.target.value);
}

async function ponBoxConstructSave(event) {
  WritePonBoxConstruction(event, coordinatesPonBox, selectedPonBox, commentTextAreaRefPonBox, selectedCity, ponBoxMarker,
    showSnackbar, setCoordinatesPonBox, setCommentPonBox,cantonPonBoxRefresh, setSelectedPonBox, user,highwayTerritory,
    projectId, dividerId, setDividerId, setSelectedDividerOption, adapterPonBoxCount, selectedPolishing, pigtailPonBoxCount, 
    setAdapterPonBoxCount, setPigtailPonBoxCount, setSelectedPolishing);
}

//#endregion

useEffect(() => {
  const fetchData = async () => {
    try {
      const [
        cableData,
        cableTypeData,
        couplingData,
        fobData,
        ponBoxData,
        rankCableData,
        rankComponentData,
        contractorData,
        ownerWellData,
        ownerPillarData,
        dividerData,
        boxData,
        polishingData,
        cassetteData,
      ] = await Promise.all([
        loadingCableDataComponent(),
        loadingCableTypeDataComponent(),
        loadingCouplingDataComponent(),
        loadingFobDataComponent(),
        loadingPonBoxDataComponent(),
        loadingRankCableDataComponent(),
        loadingRankComponentDataComponent(),
        loadingContractorDataComponent(),
        loadingOwnerWellDataComponent(),
        loadingOwnerPillarDataComponent(),
        loadingDividerDataComponent(),
        loadingBoxDataComponent(),
        loadingPolishingDataComponent(),
        loadingCassetteDataComponent(),
      ]);

      setCableData(cableData);
      setCableTypeData(cableTypeData);
      setCouplingData(couplingData);
      setFobData(fobData);
      setPonBoxData(ponBoxData);
      setRankCableData(rankCableData);
      setRankComponentData(rankComponentData);
      setContractorData(contractorData);
      setOwnerWellData(ownerWellData);
      setOwnerPillarData(ownerPillarData);
      setDividerData(dividerData);
      setBoxData(boxData);
      setPolishingData(polishingData);
      setCassetteData(cassetteData);
    } catch (error) {
      console.error("Ошибка загрузки данных:", error);
    }
  };

  fetchData();
}, []);
//#region ЗАГРУЗКА ДАННЫХ

 
  return (
    <Drawer
      open={openEditCantonDrawer}
      onClose={toggleEditCantonDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar' }}     
    >
      <div className="divTitleDrawer">
            <p className='textTitleDrawer'>Режим внесения</p>
      </div>
      <List  >
        <div className='divBodyDrawer'>
          <p className='textTitleDrawer'>Оптоволоконный кабель</p>

          {/* Кабель */}
          <CableContainerEdit
            toggleVisibilityCable={toggleVisibilityCable}
            isVisibleCable={isVisibleCable}
            cableData={cableData}     
            handleCableSelectChange={handleCableSelectChange}
            cableTypeData={cableTypeData}
            handleLineStyleSelectChange={handleLineStyleSelectChange}
            contractorData={contractorData}
            selectedContractor={selectedContractor}
            handleChangeContractor={handleChangeContractor}
            commentCable={commentCable}
            commentTextAreaRefCable={commentTextAreaRefCable}
            handleCommentChangeCable={handleCommentChangeCable}
            isLineDrawing={isLineDrawing}
            handleStartDrawing={handleStartDrawing}
            handleStopDrawing={handleStopDrawing}
            handleCableConstructSave={handleCableConstructSave}
            selectedCable={selectedCable}
            handleChangeCableSelect={handleChangeCableSelect}
            selectedTypeCable={selectedTypeCable}
            handleChangeCableType={handleChangeCableType}
            rankCableData={rankCableData}
            handleChangeRankCable={handleChangeRankCable}
            selectedRankCable={selectedRankCable}
            reserve={reserve}
            setReserve={setReserve}
            forwarding={forwarding}
            setForwarding={setForwarding}
            polishingData={polishingData}
            cassetteData={cassetteData}
            showCassetteCable={showCassetteCable}
            setShowCassetteCable={setShowCassetteCable}
            selectedPolishingPatch={selectedPolishingPatch}
            setSelectedPolishingPatch={setSelectedPolishingPatch}
            selectedCassetteModel={selectedCassetteModel}
            setSelectedCassetteModel={setSelectedCassetteModel}
            cassetteCableCount={cassetteCableCount}
            setCassetteCableCount={setCassetteCableCount}
            patchCableCount={patchCableCount}
            setPatchCableCount={setPatchCableCount}
          />         
       </div>

        <div className="divBodyDrawer">
          <p className='textTitleDrawer'>Коммуникации</p>

           
           
           {/* Муфта */}
           <CouplingContainerEdit
             toggleVisibilityCoupling={toggleVisibilityCoupling}
             isVisibleCoupling={isVisibleCoupling}
             couplingData={couplingData}
             handleChangeCoupling={handleChangeCoupling}
             selectedCoupling={selectedCoupling}
             commentCoupling={commentCoupling}
             commentTextAreaRefCoupling={commentTextAreaRefCoupling}
             handleCommentChangeCoupling={handleCommentChangeCoupling}
             toggleCouplingMarker={toggleCouplingMarker}
             couplingMarker={couplingMarker}
             couplingConstructSave={couplingConstructSave}
             rankComponentData={rankComponentData}
             handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
             selectedRankCouling={selectedRankCouling}
             setWeldsCoupling={setWeldsCoupling}
             weldsCoupling={weldsCoupling}
           />
              
          {/* Фоб */}
          <FobContainerEdit
             toggleVisibilityFob={toggleVisibilityFob}
             isVisibleFob={isVisibleFob}
             fobData={fobData}
             handleChangeFob={handleChangeFob}
             selectedFob={selectedFob}
             commentFob={commentFob}
             commentTextAreaRefFob={commentTextAreaRefFob}
             handleCommentChangeFob={handleCommentChangeFob}
             toggleFobMarker={toggleFobMarker}
             fobMarker={fobMarker}
             fobConstructSave={fobConstructSave}
             rankComponentData={rankComponentData}
             handleChangeRankComponentFob={handleChangeRankComponentFob}
             selectedRankFob={selectedRankFob}
             dividerData={dividerData}  
             selectedDividerOptionFob={selectedDividerOptionFob} 
             handleChangeDividerSelectFob={handleChangeDividerSelectFob}
             boxData={boxData}
             selectedBox={selectedBox} 
             handleChangeBox={handleChangeBox}
             polishingData={polishingData}
             selectedPolishing={selectedPolishing}
             handleChangePolishing={handleChangePolishing}
             handleAdapterChange={handleAdapterChange}
             adapterCount={adapterCount}
             handlePigtailChange={handlePigtailChange}
             pigtailCount={pigtailCount}
            
          />

           {/* Пон-бокс */}
           <PonBoxContainerEdit
              toggleVisibilityPonBox={toggleVisibilityPonBox}
              isVisiblePonBox={isVisiblePonBox}
              ponboxData={ponboxData}
              handleChangePonBox={handleChangePonBox}
              selectedPonBox={selectedPonBox}
              commentPonBox={commentPonBox} 
              commentTextAreaRefPonBox={commentTextAreaRefPonBox}
              handleCommentChangePonBox={handleCommentChangePonBox}
              togglePonBoxMarker={togglePonBoxMarker}
              ponBoxMarker={ponBoxMarker}
              ponBoxConstructSave={ponBoxConstructSave}  
              dividerData={dividerData}  
              selectedDividerOption={selectedDividerOption} 
              handleChangeDividerSelect={handleChangeDividerSelect}
              polishingData={polishingData}
              selectedPolishing={selectedPolishing}
              handleChangePolishing={handleChangePolishing}
              handleAdapterChange={handleAdapterPonBoxChange}
              adapterCount={adapterPonBoxCount}
              handlePigtailChange={handlePigtailPonBoxChange}
              pigtailCount={pigtailPonBoxCount}
          />
        </div>
      </List>
       
      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        ContentProps={{
          style: {
            backgroundColor: snackbarClass === 'snackbarWarning' ? 'rgb(235, 235, 187)' : 'rgb(193, 255, 174)',
            color: 'black'
          }
        }}
      />

    </Drawer>    
  );
};

export default DrawerEditComponent;